module.exports = __webpack_public_path__ + "img/Login-logo.5927b970.png";